import React from 'react';
import styles from './not-moderated-chats.module.scss';
import { Button, Typography } from '@/ui-kit';
import { MessageIcon, RemoderationIcon } from '@/assets/icons';
import { routesApp } from '@/constans/routes';
import { Trans, useTranslation } from 'react-i18next';

interface Props {}

export const NotModeratedChats: React.FC<Props> = () => {
    const { t } = useTranslation();

    return (
        <div className={styles.wrapper}>
            <RemoderationIcon className={styles.remoderationCardContentIcon} />
            <Typography
                fontWeight="semibold"
                center
                fontFamily="SFProText"
                className={styles.title}>
                <Trans i18nKey="please_edit_your_details" />
            </Typography>
            <Typography
                center
                fontFamily="SFProText"
                className={styles.text}>
                {t('passing_verification_note')}
            </Typography>
            <Button
                className={styles.button}
                typeColor="orange"
                isLink
                to={routesApp.profileEdit}>
                {t('go_to_profile')}
            </Button>
        </div>
    );
};
